var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.5V0.5L18.5 6.5H12.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5H11V6C11 7.10457 11.8954 8 13 8H18.5V22.5C18.5 23.6046 17.6046 24.5 16.5 24.5H2.5C1.39543 24.5 0.5 23.6046 0.5 22.5V2.5C0.5 1.39543 1.39543 0.5 2.5 0.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5C4.5 16.9477 4.94772 16.5 5.5 16.5C6.05228 16.5 6.5 16.9477 6.5 17.5V20.5C6.5 21.0523 6.05228 21.5 5.5 21.5C4.94772 21.5 4.5 21.0523 4.5 20.5V17.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.5C8.5 10.9477 8.94772 10.5 9.5 10.5C10.0523 10.5 10.5 10.9477 10.5 11.5V20.5C10.5 21.0523 10.0523 21.5 9.5 21.5C8.94772 21.5 8.5 21.0523 8.5 20.5V11.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5C12.5 13.9477 12.9477 13.5 13.5 13.5C14.0523 13.5 14.5 13.9477 14.5 14.5V20.5C14.5 21.0523 14.0523 21.5 13.5 21.5C12.9477 21.5 12.5 21.0523 12.5 20.5V14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.f1a65884e0d4d59d3d23ca68244c2b15.svg";
export { ForwardRef as ReactComponent };